import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useKidStore, useKidDetailsApi } from '@pages/kid'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  const kidId = to.params.id

  if (typeof kidId !== 'string' || !kidId) return

  const kidStore = useKidStore()

  // A query-only change (changelog filters, pagination) keeps the loaded kid.
  if (to.path === from.path && String(kidStore.getKid?.id) === kidId) return

  // Wipe the previous kid so its form can never be shown (or saved) under another kid.
  kidStore.reset()

  void useKidDetailsApi({ kidId })
})
